import { RootState } from '@store';
import { createSelector } from 'reselect';
import { Notifications, Alert } from '@types';
import { AlertState, notification } from '@store/reducers/alert.reducer';
import { isEmpty, sortBy } from 'lodash';
import { selectGetSelectedLoanNumber } from './widgets.selectors';

const alertSlice = (state: RootState) => state?.notification || notification;

export const selectNotifications = createSelector([alertSlice], (slice: AlertState): Alert => slice.notification);

export const SelectNotificationsData = createSelector([selectNotifications], (data: Alert): Notifications[] => data?.notifications);

export const selectNotificationsFilterData = createSelector(
    [SelectNotificationsData, selectGetSelectedLoanNumber],
    (notification, selectedAccount): any => {
        const sortingOrder = ['emergency', 'warning', 'schedule'];
        if (!isEmpty(notification) && selectedAccount) {
            const loanType: string = selectedAccount.loanType && selectedAccount.loanType !== '' ? selectedAccount.loanType : 'default';
            const sortedNotifications = sortBy(notification, each => {
                const eleIndex = sortingOrder.indexOf(each.template.templateIcon);

                return eleIndex !== -1 ? eleIndex : notification.length;
            });

            const finalNotifications: any = [];

            let checkIfSelectedLoanTypeMatchesNotificationsLoanType = false;
            sortedNotifications.map(opt => {
                if (opt.loanType === 'common' || opt.loanType === loanType) {
                    finalNotifications.push(opt);
                    checkIfSelectedLoanTypeMatchesNotificationsLoanType =
                        opt.loanType === loanType ? true : checkIfSelectedLoanTypeMatchesNotificationsLoanType;
                }
            });
            if (!checkIfSelectedLoanTypeMatchesNotificationsLoanType) {
                const index = sortedNotifications.findIndex(e => e.loanType === 'default');
                if (index !== -1) {
                    finalNotifications.unshift(sortedNotifications[index]);
                }
            }
            return finalNotifications.slice(0, 2);
        }
    }
);
